import React, { useState } from 'react';
import InquiryModal from '../../components/features/InquiryModal';
import StatsBand, { STAT_ITEMS } from '../../components/home/StatsBand';
import { MissionSection } from '../../components/home/MissionValues';
import ClosingCta from '../../components/home/ClosingCta';

/*
 * 회사소개(헤더 '회사소개') — 랜딩페이지와 같은 디자인, 같은 부품을 쓴다.
 *
 * 메뉴를 늘리지 않으려고 '가치' 자리를 '회사소개' 로 바꾸고, 가치는 이 안에서 짧게 소개한다
 * (2026-10-23 사용자). 연혁은 넣지 않는다(사용자 결정).
 * 홈 주소는 그대로 랜딩페이지다 — 검색은 도메인 첫 주소를 회사 대표 페이지로 보고, 랜딩은
 * 견적·상담으로 이끄는 화면이라 '어떤 회사인가' 를 보여 주는 이 페이지와 역할이 다르다.
 *
 * 회사 정보(상호·대표·소재지·연락처) 칸은 두지 않는다 — 같은 정보가 모든 페이지 푸터와
 * 문의하기에 있다(2026-10-26 사용자).
 *
 * 숫자 띠·미션과 핵심가치·마무리 상담은 메인과 같은 컴포넌트다 — 한 곳을 고치면 같이 바뀐다.
 */
const About = () => {
    const [modal, setModal] = useState({ isOpen: false, type: 'CONTACT' });

    return (
        <div className="bg-surface-bg min-h-screen pb-24">
            <InquiryModal
                isOpen={modal.isOpen}
                onClose={() => setModal((prev) => ({ ...prev, isOpen: false }))}
                type={modal.type}
            />

            {/* ── 첫 화면 — 메인 첫 화면과 같은 크기·여백 ───────────────── */}
            <section className="pt-36 md:pt-44 pb-20 px-6 text-center">
                <div className="max-w-4xl mx-auto">
                    <p className="text-sm md:text-base font-extrabold text-primary-700 tracking-wide">회사소개</p>
                    <h1 className="mt-3 text-4xl/normal sm:text-5xl/normal md:text-6xl/normal font-extrabold text-gray-900 tracking-tight break-keep">
                        가까운솔루션
                    </h1>
                    <p className="mt-6 text-lg/relaxed md:text-2xl/relaxed text-gray-600 font-medium break-keep text-balance">
                        {/* "(ESL)" 이 줄 맨 앞으로 떨어지지 않게 앞말과 붙여 둔다. */}
                        전자 가격표·전자 명패·<span className="whitespace-nowrap">전자 라벨(ESL)</span> 도입을 컨설팅부터 설치,
                        교육과 사후관리까지 직접 맡습니다.
                    </p>
                    <StatsBand
                        items={[STAT_ITEMS.projects, STAT_ITEMS.solutions, STAT_ITEMS.regions]}
                        className="mt-14 pt-10 border-t border-gray-200"
                    />
                </div>
            </section>

            {/* ── 미션과 핵심가치 — 메인 4번 섹션 그대로 ──────────────────── */}
            <MissionSection />

            {/* ── 마무리 — 메인과 같은 상담 블록 ─────────────────────────── */}
            <ClosingCta onRequest={() => setModal({ isOpen: true, type: 'CONTACT' })} />
        </div>
    );
};

export default About;
